<template>
  <div>
  <v-dialog v-model="isModalOpen" max-width="500">
      <template v-slot:activator="{ on, attrs }"> </template>

      <v-card>
        <v-card-title>
          <span style="font-weight: bold; font-size: 18px"
            >Selecione o Cliente</span
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="margin-top: -30px">
          <form @submit.prevent="handleSubmit">
            <v-radio-group v-model="selectedCliente">
              <v-radio
                v-for="cliente in clientes"
                :key="cliente.id"
                :label="
                  cliente.email
                    ? `${cliente.nome} - ${cliente.email}`
                    : cliente.nome
                "
                :value="cliente.id"
              >
              </v-radio>
              <v-radio
                label="Uso pessoal ou para todos os clientes"
                value="0"
              ></v-radio>
            </v-radio-group>
          </form>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="closeModal">Cancelar</v-btn>
          <v-btn color="primary" @click="handleSubmit">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
  <v-container grid-list-md>
    <v-layout row wrap justify-end>
      <v-flex>
        <div
          style="
            overflow: auto;
            max-height: 300px;
            box-shadow: 4px 5px 4px #e5e5e5;
            padding: 10px;
          "
        >
          <v-flex pb-2>
            <v-treeview
              ref="dTreeAlimentos"
              :style="heightTree"
              :items="categorias_alimentos.filter((c) => c.id < 900)"
              :search="search"
              :item-text="
                idioma === 0 ? 'name' : idioma === 1 ? 'name_en' : 'name_es'
              "
              :active.sync="alimentoClick"
              :open.sync="open"
              v-model="treeAlimentos"
              :open-all="expandeArvore"
              :selectable="false"
              item-children="derivados"
              active-class="grey lighten-4 indigo--text"
              selected-color="indigo"
              activatable
              transition
              expand-icon=""
              on-icon="mdi-checkbox-marked"
              off-icon="mdi-checkbox-blank-outline"
              indeterminate-icon="mdi-minus-box"
              return-object
            >
              <template v-if="!item.oculto" slot="label" slot-scope="{ item }">
                <span
                  v-if="item.derivados && !item.oculto"
                  style="
                    cursor: pointer;
                    font-weight: 600;
                    text-decoration-color: grey;
                  "
                  @click="open = open[0] !== item ? [item] : []"
                >
                  <v-icon>{{
                    open[0] === item ? "mdi-chevron-down" : "mdi-chevron-right"
                  }}</v-icon>
                  {{ Object.values(item.derivados).lenght }}
                  {{
                    idioma === 0
                      ? item.name
                      : idioma === 1
                      ? item.name_en
                      : item.name_es
                  }}
                </span>

                <template v-else>
                  <span v-show="item.EXCLUIDO === 0" style="cursor: pointer"
                    >{{ [alimentoBase].includes(item) ? "*" : ""
                    }}{{
                      idioma === 0
                        ? item.name
                        : idioma === 1
                        ? item.name_en
                        : item.name_es
                    }}
                    <v-icon
                      v-if="item.patrocinado"
                      :title="strings[idioma].recomendado_brcorte"
                      color="primary"
                      >mdi-star</v-icon
                    >
                    <v-icon
                      v-if="item.patrocinado"
                      :title="strings[idioma].recomendado_brcorte"
                      color="primary"
                      @click="
                        info = true;
                        verEmpresa(item);
                      "
                      >mdi-information</v-icon
                    >
                  </span>
                </template>
              </template>
            </v-treeview>
          </v-flex>
        </div>
        <h2>{{ strings[idioma].voce_esta_editando }}:</h2>
        <h4>
          {{
            alimentoBase && alimentoBase.name && !alimentoBase.derivados
              ? idioma === 0
                ? alimentoBase.name
                : idioma === 1
                ? alimentoBase.name_en
                : alimentoBase.name_es
              : "-"
          }}
        </h4>
        <material-card>
          <v-list>
            <div>
              <div class="title">
                {{ strings[idioma].identificacao_alimento }}
              </div>
              <template>
                <v-list-tile class="list-restricoes">
                  <v-list-tile-content>
                    <v-layout
                      align-center
                      justify-space-around
                      row
                      py-2
                      style="width: 100%"
                    >
                      <v-flex xs7 sm8 md5>
                        <label :for="'nome'">
                          <span style="font-weight: 1000">
                            {{ strings[idioma].nome_alimento_portugues }}: *
                          </span>
                        </label>
                      </v-flex>
                      <v-flex xs5 sm4 md7>
                        <v-text-field
                          v-model="alimento.nome"
                          :id="'nome'"
                          color="primary"
                        />
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider />
                <v-list-tile class="list-restricoes">
                  <v-list-tile-content>
                    <v-layout
                      align-center
                      justify-space-around
                      row
                      py-2
                      style="width: 100%"
                    >
                      <v-flex xs7 sm8 md5>
                        <span style="font-weight: 500">
                          {{ strings[idioma].nome_ingles }}:
                        </span>
                      </v-flex>
                      <v-flex xs5 sm4 md7>
                        <v-text-field
                          v-model="alimento.nome_ingles"
                          color="primary"
                        />
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider />
                <v-list-tile class="list-restricoes">
                  <v-list-tile-content>
                    <v-layout
                      align-center
                      justify-space-around
                      row
                      py-2
                      style="width: 100%"
                    >
                      <v-flex xs7 sm8 md5>
                        <span style="font-weight: 500">
                          {{ strings[idioma].nome_espanhol }}:
                        </span>
                      </v-flex>
                      <v-flex xs5 sm4 md7>
                        <v-text-field
                          v-model="alimento.nome_espanhol"
                          color="primary"
                        />
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider />
                <v-list-tile class="list-restricoes">
                  <v-list-tile-content>
                    <v-layout
                      align-center
                      justify-space-around
                      row
                      py-2
                      style="width: 100%"
                    >
                      <v-flex xs7 sm8 md5>
                        <span style="font-weight: 500">
                          {{ strings[idioma].nome_cientifico }}:
                        </span>
                      </v-flex>
                      <v-flex xs5 sm4 md7>
                        <v-text-field
                          v-model="alimento.nome_sci"
                          color="primary"
                          readonly
                          disabled
                        />
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider />
                <v-list-tile class="list-restricoes">
                  <v-list-tile-content>
                    <v-layout
                      align-center
                      justify-space-around
                      row
                      py-2
                      style="width: 100%"
                    >
                      <v-flex xs7 sm8 md5>
                        <span style="font-weight: 1000">
                          {{ strings[idioma].tipo_alimento }}: *
                        </span>
                      </v-flex>
                      <v-flex xs5 sm4 md7>
                        <v-select
                          key="id"
                          v-model="alimento.tipo"
                          v-bind="binding"
                          :items="tipos.filter((tipo) => tipo.id < 900)"
                          :item-text="
                            (item) =>
                              idioma === 0
                                ? item.nome
                                : idioma === 1
                                ? item.nome_ingles
                                : item.nome_espanhol
                          "
                          item-value="id"
                          class="text-field-table"
                          readonly
                          disabled
                          dense
                        />
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider />
              </template>
            </div>
          </v-list>
          <v-list>
            <div class="title">
              {{ strings[idioma].informacoes_nutricionais }}
            </div>
            <template v-for="(ingrediente, index) in ingredientes">
              <v-tooltip :key="index" right>
                <template v-slot:activator="{ on }">
                  <v-list-tile
                    :key="index"
                    :style="
                      limite.id === ingrediente.id
                        ? 'background: grey; color: #fff;'
                        : 'background: #fff; color: #000;'
                    "
                    class="list-restricoes"
                  >
                    <v-list-tile-content>
                      <v-layout
                        align-center
                        justify-space-around
                        row
                        py-2
                        style="width: 100%"
                      >
                        <v-flex xs7 sm8 md9>
                          <label
                            :for="ingrediente.id"
                            v-on="ingrediente.alt ? on : null"
                          >
                            <span
                              :style="
                                (ingrediente.id !== 'MS' &&
                                  ingrediente.id !== 'NDT_BRCORTE2016' &&
                                  ingrediente.id !== 'PB' &&
                                  alimento.tipo > 8) ||
                                ingrediente.id !== 'MS'
                                  ? 'font-weight: 500'
                                  : 'font-weight: 1000'
                              "
                            >
                              {{
                                idioma === 0
                                  ? ingrediente.exigencia +
                                    " (" +
                                    (ingrediente.codigo
                                      ? ingrediente.codigo
                                      : ingrediente.sigla) +
                                    ")"
                                  : idioma === 1
                                  ? ingrediente.exigencia_en +
                                    " (" +
                                    (ingrediente.codigo_en
                                      ? ingrediente.codigo_en
                                      : ingrediente.sigla) +
                                    ")"
                                  : ingrediente.exigencia_es +
                                    " (" +
                                    (ingrediente.codigo_es
                                      ? ingrediente.codigo_es
                                      : ingrediente.sigla) +
                                    ")"
                              }}
                              <span v-if="ingrediente.id === 'MS'"
                                >*</span
                              ></span
                            >
                          </label>
                        </v-flex>
                        <v-flex xs5 sm4 md3>
                          <v-text-field
                            v-model="alimento.nutrientes[ingrediente.id]"
                            :id="ingrediente.id"
                            :title="
                              idioma === 0
                                ? ingrediente.exigencia
                                : idioma === 1
                                ? ingrediente.exigencia_en
                                : ingrediente.exigencia_es
                            "
                            :suffix="
                              !ingrediente.unidade_alt
                                ? idioma === 0
                                  ? ingrediente.unidade
                                  : idioma === 1
                                  ? ingrediente.unidade_en
                                  : ingrediente.unidade_es
                                : idioma === 0
                                ? ingrediente.unidade_alt
                                : idioma === 1
                                ? ingrediente.unidade_alt_en
                                : ingrediente.unidade_alt_es
                            "
                            :value="
                              alimento.nutrientes[ingrediente.id]
                                ? alimento.nutrientes[ingrediente.id]
                                : '0.00'
                            "
                            :color="
                              limite.id === ingrediente.id ? 'white' : 'primary'
                            "
                            class="text-field-table text-field-nutrientes"
                            pattern="\d*"
                            inputmode="decimal"
                            v-on="ingrediente.alt ? on : null"
                            @click="loadNutrienteLimite(ingrediente.id)"
                            @focus="loadNutrienteLimite(ingrediente.id)"
                            @change="
                              (val) =>
                                changeIngrediente(
                                  ingrediente.id,
                                  val,
                                  ingrediente.unidade
                                )
                            "
                          />
                          <!-- AB#5427
                             <small
                            v-if="limite.id === ingrediente.id"
                            style="color: #fff"
                            >{{ strings[idioma].minimo_exigencia }}:
                            {{ limite.menor > 0 ? limite.menor : 0 }};
                            {{ strings[idioma].maximo_exigencia }}:
                            {{ limite.maior > 0 ? limite.maior : 100 }}</small
                          > -->
                        </v-flex>
                      </v-layout>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <span v-if="ingrediente.alt">{{
                  strings[idioma][ingrediente.alt]
                }}</span>
              </v-tooltip>
            </template>
          </v-list>
          <v-layout row wrap justify-end>
            <v-btn
              v-if="
                alimentoBase && alimentoBase !== null && !alimentoBase.derivados
              "
              color="primary"
              @click="enviaBasePessoal()"
            >
              {{ strings[idioma].salvar }}
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-layout>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  getAlimentosEmpresa,
  updateData,
  createMD5,
  getAlimentos,
} from "@/utils/utils";
import { ENVIAR_ALIMENTO_ADAPTADO } from "../../utils/types";

export default {
  data: () => ({
    limite: { sigla: null, menor: 0, maior: 100 },
    alimentoBase: null,
    etapaAlimentoBase: true,
    alimento: {
      nome: "",
      nome_sci: "",
      tipo: null,
      nutrientes: {},
      user: {},
    },
    step: 1,
    loadingAlimentos: false,
    escolha: false,
    basePessoal: true,
    stepComplete: [false, false],
    alimentosUsuario: [],
    alimentoClick: [],
    arrayTable: [
      {
        id: "ok",
      },
    ],
    calculandoDieta: false,
    calculandoNutrientes: false,
    changeMinMax: false,
    dialogNutrientes: false,
    dietaOtimizada: false,
    dietaSemiOtima: false,
    editarExigencias: false,
    loadingStep2: false,
    indexAlimentoDialog: 0,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    open: [],
    pagination: {
      rowsPerPage: 20,
      sortBy: null,
      descending: false,
      page: 1,
      totalItems: 0,
    },
    recalculandoExigencias: false,
    search: null,
    searchRestricao: null,
    fixaVC: false,
    treeAlimentos: [],
    validAnimal: false,
    selected: false,
    indetermined: false,
    volumososSelecionados: [],
    concentradoSelecionados: [],
    selecionaComuns: false,
    expandeArvore: false,
    travaSelectAll: false,
    info: false,
    clientes: [],
    isModalOpen: false,
    selectedCliente: null,
  }),
  computed: {
    ...mapState("app", [
      "strings",
      "idioma",
      "user",
      "ingredientes",
      "ingredientesCompletos",
      "optionsNumber",
      "alimentos_selecionados",
      "categorias_alimentos",
      "alert",
      "empresa",
      "acesso_premium",
      "tipos",
    ]),

    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true;
      else binding.row = false;
      return binding;
    },
    selectable() {
      return this.open.length > 0;
    },
    heightCard() {
      return String(this.$vuetify.breakpoint.height - 289) + "px";
    },
    heightOverflow() {
      return (
        "max-height: " +
        String(this.$vuetify.breakpoint.height - 120) +
        "px; overflow: auto;"
      );
    },
    filter() {
      return (item, search, textKey) => {
        // if (search.length < 3) return false
        let result = replaceSpecialChars(item[textKey])
          .toLowerCase()
          .search(new RegExp(replaceSpecialChars(search.toLowerCase()), "i"));
        return result > -1;
      };
    },
    heightTree() {
      return (
        "max-height: " +
        String(this.$vuetify.breakpoint.height - 360) +
        "px; overflow: auto; min-height: 200px;"
      );
    },
  },
  watch: {
    loadingAlimentos(val) {
      let loading = val;
      this.$store.commit("setLoading", loading);
    },
    alimentoBase(val) {
      if (val === null) return this.resetAlimento();
      if (val.nutrientes === undefined) return;
      this.alimento.nome = val.name;
      this.alimento.nome_ingles = val.name_en;
      this.alimento.nome_sci = val.name_sci;
      this.alimento.tipo = val.tipo;
      this.alimento.nutrientes = val.nutrientes;
      for (let nut in this.alimento.nutrientes) {
        this.alimento.nutrientes[nut] = parseFloat(
          this.alimento.nutrientes[nut]
        )
          .toFixed(2)
          .replace(".", this.strings[this.idioma].separador_float);
      }
    },
    alimentoClick(val, old) {
      if (val.length === 0 && !val[0].derivados) {
        this.alimentoBase = null;
        this.alimentoClick = old;
      } else if (val[0].derivados) {
        this.alimentoBase = old[0];
        this.alimentoClick = old;
      } else {
        let alimento = val[0];
        if (alimento && alimento !== null) {
          setTimeout(() => {
            // alimento = JSON.parse(sessionStorage.getItem('alimentoCarregado'))
            this.alimentoBase = Object.assign({}, alimento);
            // converter g/kg para %MS (contrario)
            this.convertMacroToGKG(alimento);
            // -----------------------
          }, 300);
        }
      }
    },
    treeAlimentos(val) {
      if (Math.abs(this.alimentos_selecionados.length - val.length) > 2) {
        this.treeAlimentos = this.alimentos_selecionados;
        return;
      }
      this.$store.commit("setAlimentosSelecionados", val);
      this.pagination.totalItems = this.alimentos_selecionados.length;
      this.stepComplete[0] = val.length !== 0;
    },
    open(val) {
      if ((this.search === "" || this.search === null) && val.length > 1) {
        this.open = [val[val.length - 1]];
      }
    },
  },
  created() {
    let res = this.getAcessoModulo({
      user: this.user,
      modulo: ENVIAR_ALIMENTO_ADAPTADO,
    });
    if (!res) return this.voltar();

    this.$store.dispatch("getTipos");
    this.escolha = this.acesso_premium;
    if (!this.$store.state.app.categorias_alimentos) {
      this.loadingAlimentos = true;
      this.axios.post("alimentos/lastUpdateAt", {}).then((response) => {
        this.getClientes();
        let lastUpdate = parseInt(response.data.data[1]);
        if (lastUpdate === parseInt(localStorage.getItem("lastUpdate"))) {
          let tipos = JSON.parse(localStorage.getItem("tipos"));
          let alimentos = JSON.parse(localStorage.getItem("alimentos"));
          this.$store.commit("setAlimentos", {
            tipos: tipos,
            alimentos: alimentos,
          });
          this.loadingAlimentos = false;
        } else {
          this.axios.post("tipos", {}).then((response) => {
            let tipos = response.data.data;
            localStorage.setItem("tipos", JSON.stringify(tipos));
            this.axios
              .post("relatorio/alimentosBrCorte", {})
              .then((response) => {
                localStorage.setItem(
                  "alimentos",
                  JSON.stringify(response.data.data)
                );
                this.$store.commit("setAlimentos", {
                  tipos: tipos,
                  alimentos: response.data.data,
                });
                this.loadingAlimentos = false;
                localStorage.setItem("lastUpdate", lastUpdate);
              })
              .catch((error) => {
                console.log(error);
              });
          });
        }
      });
    }

    let alimento = JSON.parse(sessionStorage.getItem("alimentoCarregado"));
    if (alimento && alimento !== null) {
      setTimeout(() => {
        // alimento = JSON.parse(sessionStorage.getItem('alimentoCarregado'))
        this.alimento = Object.assign({}, alimento);
        // converter g/kg para %MS (contrario)
        this.alimento.nutrientes = this.convertMacroToGKGPessoal(alimento);
        // -----------------------
        if (this.alimento.nome !== "" && this.alimentoBase) this.selectedCliente =  this.alimento.id_cliente ?  this.alimento.id_cliente : "0";
      }, 300);
      // this.alimentoBase = alimentosCarregados[alimento.id_alimento_pai]
      let alimentosCarregados = JSON.parse(
        localStorage.getItem("alimentosStored")
      );
      this.alimentoBase = alimentosCarregados[alimento.id_alimento_pai];
    }

    sessionStorage.removeItem("alimentoCarregado");
  },
  methods: {
    voltar() {
      alert(this.strings[this.idioma].funcionalidade_exclusiva_premium);
      window.location.href = "/enviar-alimento";
    },
    convertMStoGKG(val) {
      return val * 10;
    },
    convertGKGtoMS(val) {
      return val / 10;
    },
    convertMacroToMS(alimento) {
      let nutrientes = JSON.parse(JSON.stringify(alimento.nutrientes));
      for (let ingrediente of Object.values(this.ingredientesCompletos)) {
        if (!ingrediente.fator_conv_alt) continue;
        let val = null;
        if (
          !nutrientes[ingrediente.id] ||
          nutrientes[ingrediente.id] === null
        ) {
          val = 0;
        } else {
          val = this.convertGKGtoMS(
            String(nutrientes[ingrediente.id]).replace(
              this.strings[this.idioma].separador_float,
              "."
            )
          );
        }
        if (val === 0) nutrientes[ingrediente.id] = "";
        else
          nutrientes[ingrediente.id] = val
            .toFixed(3)
            .replace(".", this.strings[this.idioma].separador_float);
      }

      return { ...nutrientes };
    },
    convertMacroToGKG(alimento) {
      let nutrientes = JSON.parse(JSON.stringify(alimento.nutrientes_originais));
      for (let ingrediente of Object.values(this.ingredientesCompletos)) {
        if (!ingrediente.fator_conv_alt) continue;
        let val = null;
        if (
          !nutrientes[ingrediente.id] ||
          nutrientes[ingrediente.id] === null
        ) {
          val = 0;
        } else {
          val = this.convertMStoGKG(
            String(nutrientes[ingrediente.id]).replace(
              this.strings[this.idioma].separador_float,
              "."
            )
          );
        }
        if (val === 0) nutrientes[ingrediente.id] = "";
        else {
          this.alimentoBase.nutrientes[ingrediente.id] =
            parseFloat(val).toFixed(2);
        }
      }
    },
    convertMacroToGKGPessoal(alimento) {
      let nutrientes = JSON.parse(JSON.stringify(alimento.nutrientes));
      for (let ingrediente of Object.values(this.ingredientesCompletos)) {
        if (!ingrediente.fator_conv_alt) continue;
        let val = null;
        if (
          !nutrientes[ingrediente.id] ||
          nutrientes[ingrediente.id] === null
        ) {
          val = 0;
        } else {
          val = this.convertMStoGKG(
            String(nutrientes[ingrediente.id]).replace(
              this.strings[this.idioma].separador_float,
              "."
            )
          );
        }
        if (val === 0) nutrientes[ingrediente.id] = "";
        else {
          nutrientes[ingrediente.id] =
            parseFloat(val).toFixed(2).replace(".", this.strings[this.idioma].separador_float);
        }
      }
      return { ...nutrientes };
    },
    filter() {
      return (item, search, textKey) =>
        item[textKey].toLowerCase().search(search.toLowerCase()) > -1;
    },
    loadNutrienteLimite(sigla) {
      this.limite["id"] = sigla;
      this.axios
        .post("composicao/nutrienteLimite", { sigla: sigla })
        .then((res) => {
          this.limite = res.data.data;
          this.limite["id"] = sigla;
        })
        .catch((err) => {
          this.limite = {};
          this.limite.menor = 0;
          this.limite.maior = 100;
          this.limite["id"] = sigla;
          console.log(err);
        });
    },
    async loadAlimentosDieta(forced = false) {
      this.loadingAlimentos = true;
      this.loadingStep1 = true;

      return getAlimentos(this.$store, this.axios, forced)
        .then((r) => {
          this.loadingAlimentos = false;
          this.loadingStep1 = false;
        })
        .catch((e) => {
          this.loadingAlimentos = false;
          this.loadingStep1 = false;
        });
    },
    go(url) {
      window.location.href = url;
    },
    mudarEmpresa() {
      sessionStorage.removeItem("empresaAdm");
      this.go("/empresa");
    },
    enviarEmpresa() {
      sessionStorage.removeItem("empresaAdm");
      sessionStorage.removeItem("alimentoCarregado");
      this.go("/empresa/add-alimento");
    },
    resetAlimento() {
      this.alimento = {
        nome: "",
        nome_sci: "",
        tipo: null,
        nutrientes: {},
        user: {},
      };
    },
    openAlimento(al) {
      let alimento = Object.assign({}, al);
      alimento.nome_sci = alimento.nome_cientifico;
      alimento.tipo = alimento.id_tipo;
      for (let nut in alimento.nutrientes) {
        alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut]).toFixed(
          2
        );
        if (!isNaN(alimento.nutrientes[nut])) {
          alimento.nutrientes[nut] = alimento.nutrientes[nut].replace(
            ".",
            this.strings[this.idioma].separador_float
          );
        } else {
          alimento.nutrientes[nut] = "";
        }
      }
      this.alimento = alimento;
      this.stepComplete[0] = true;
      this.step = 2;
      this.basePessoal = true;
      sessionStorage.setItem("alimentoCarregado", JSON.stringify(alimento));
    },
    removeAlimento(al) {
      delete this.remove;
      if (confirm(this.strings[this.idioma].msg_remove)) {
        this.axios
          .post("alimentos/removeAlimento", { id: al.id })
          .then((res) => {
            let meusAlimentos = [];
            this.axios
              .post("alimentos/getAlimentosUsuario", {
                id_pessoa: this.user.id,
              })
              .then((res) => {
                for (let al of res.data.data) {
                  let alim = Object.assign({}, al);
                  alim["nutrientes"] = JSON.parse(al.nutrientes);
                  meusAlimentos.push(alim);
                }
                this.alimentosUsuario = meusAlimentos;
                // this.$store.commit('setAlimentosUsuario', { alimentos: meusAlimentos })
              });
          })
          .catch(() => alert("Erro, ao remover o alimento!!!"));
      }
    },
    changeIngrediente(ingrediente, nutriente, unidade) {
      if (nutriente === null || nutriente === undefined) {
        nutriente = 0;
      }
      if (typeof nutriente === "number") {
        nutriente = nutriente
          .toFixed(2)
          .replace(".", this.strings[this.idioma].separador_float);
      }
      let val = parseFloat(
        nutriente.replace(this.strings[this.idioma].separador_float, ".")
      );
      this.alimento.nutrientes[ingrediente] = isNaN(
        this.alimento.nutrientes[ingrediente]
      )
        ? 0
        : this.alimento.nutrientes[ingrediente];
      this.alimento.nutrientes[ingrediente] = parseFloat(
        isNaN(parseFloat(val)) ? 0 : val
      )
        .toFixed(2)
        .replace(".", this.strings[this.idioma].separador_float);
      if (unidade === "%" && val > 100) {
        let msg = this.strings[this.idioma].cuidado_valores_maiores_100;
        let time = 6000;
        this.$store.commit("openErrorAlert", { msg, time });
      }

      /* if (unidade === '%') {
        this.alimento.nutrientes[ingrediente] = this.idioma === 0 ? (val > 100 ? 100 : (val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : (val > 100 ? 100 : (val < 0) ? 0 : val).toFixed(2).replace('.', ',')
      } else {
        this.alimento.nutrientes[ingrediente] = this.idioma === 0 ? ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace('.', ',')
      } */
      return this.alimento.nutrientes[ingrediente];
    },
    parseString(valor, idioma) {
      if ((idioma === 0 || idioma === 2) && valor && valor !== "-") {
        if (parseFloat(valor).toFixed(2)[valor.length - 3] === ".")
          return parseFloat(valor);
        return parseFloat(valor.replace(/[.]/g, "").replace(/[,]/g, "."));
      } else if (idioma === 1 && valor && valor !== "-") {
        if (parseFloat(valor).toFixed(2)[valor.length - 3] === ",")
          return parseFloat(valor.replace(/[,]/g, "."));
        else return parseFloat(valor);
      } else if (valor && valor !== "-") {
        return parseFloat(valor.replace(/[,]/g, ""));
      }
      return 0;
    },
    async enviaBasePessoal() {
      let ms = parseFloat(
        String(this.alimento.nutrientes.MS).replace(
          this.strings[this.idioma].separador_float,
          "."
        )
      );
      let assert =
        this.alimento.nome.length >= 3 &&
        this.alimento.tipo !== null &&
        !isNaN(ms) &&
        ms > 0.0;
      if (!assert) {
        let msg =
          this.strings[this.idioma].campos_faltantes +
          (this.alimento.nome.length < 3
            ? this.strings[this.idioma].alimento_minimo_caracteres
            : "");
        let time = 6000;
        this.$store.commit("openErrorAlert", { msg, time });
        let title = this.strings[this.idioma].atencao_erro;
        this.$store.commit("openOKModal", {
          title,
          msg,
          error: true,
        });

        return;
      }

      if (this.clientes.length > 0) {
        let cliente = await this.openModal();
        cliente = parseInt(cliente);
        if (isNaN(cliente) || cliente === 0) {
          delete this.alimento.id_cliente;
        } else {
          this.alimento.id_cliente = cliente;
        }

        if (this.alimento.id === undefined) {
          delete this.alimento.id;
        }
      }

      this.alimento.id_alimento_pai = this.alimentoBase.id;
      this.alimento.user = this.user;
      this.alimento.id_pessoa = this.alimento.id_pessoa
        ? this.alimento.id_pessoa
        : this.user.id;
      if (!this.alimento.nome_ingles || this.alimento.nome_ingles === "")
        this.alimento.nome_ingles = this.alimento.nome;
      if (!this.alimento.nome_espanhol && this.alimento.nome_espanhol === "")
        this.alimento.nome_espanhol = this.alimento.nome;
      this.alimento.nome_cientifico = this.alimento.nome_sci;
      // this.alimento.id_empresa = this.empresa.id
      delete this.alimento.nome_sci;
      delete this.alimento.nutrientes_raw;
      this.alimento.id_tipo = this.alimento.tipo;
      this.alimento.nutrientes = this.convertMacroToMS(this.alimento)
      let nutrientes = Object.assign({}, this.alimento.nutrientes);
      for (let ingredienteID in this.ingredientes) {
        let ingrediente = this.ingredientes[ingredienteID];
        if (!nutrientes[ingrediente.id]) nutrientes[ingrediente.id] = "0";
        nutrientes[ingrediente.id] = parseFloat(
          String(nutrientes[ingrediente.id]).replace(
            this.strings[this.idioma].separador_float,
            "."
          )
        );
      }
      this.alimento.nutrientes = JSON.stringify(nutrientes);
      delete this.alimento.tipo;
      delete this.alimento.user;
      delete this.alimento.empresa;
      this.axios
        .post("alimentos/saveAlimento", { alimento: this.alimento })
        .then((res) => {
          let msg = this.strings[this.idioma].cadastrado;
          let title = "";
          this.$store.commit("openOKModal", { title, msg });
          this.loadAlimentosDieta(true).then(() => {
            setTimeout(() => {
              window.location.href = "/enviar-alimento";
            }, 200);
          });
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
   
    },
    envia() {
      let assert =
        this.alimento.nome.length >= 3 && this.alimento.tipo !== null;
      if (!assert) {
        let msg =
          this.strings[this.idioma].campos_faltantes +
          (this.alimento.nome.length < 3
            ? this.strings[this.idioma].alimento_minimo_caracteres
            : "");
        let time = 6000;
        this.$store.commit("openErrorAlert", { msg, time });
        let title = this.strings[this.idioma].atencao_erro;
        this.$store.commit("openOKModal", {
          title,
          msg,
          error: true,
        });

        return;
      }
      this.alimento.user = this.user;
      localStorage.setItem("alimento", this.alimento);
      let alimento = this.alimento;
      let user = this.user;
      if (this.basePessoal) {
        return this.enviaBasePessoal();
      }
      this.axios
        .post("cqbal/enviaAlimento", { alimento: alimento, user: user })
        .then((response) => {
          let msg = this.strings[this.idioma].alimento_enviado;
          let time = 6000;
          this.$store.commit("openSuccessAlert", { msg, time });
          let title = this.strings[this.idioma].cadastrado;
          this.$store.commit("openOKModal", {
            title,
            msg,
            error: false,
          });
        });
    },
    getClientes() {
      if (!this.user.consultoria || !this.user.consultoria.id) return null;
      return this.axios
        .post("consultoria/clientes", { id: this.user.consultoria.id })
        .then((r) => {
          this.clientes = r.data.data;
          return this.clientes;
        });
    },
    openModal() {
      this.isModalOpen = true;
      return new Promise((resolve) => {
        this.$once("clienteSelecionado", (cliente) => resolve(cliente));
      });
    },
    closeModal() {
      this.isModalOpen = false;
      this.carregando = false;
    },
    handleSubmit() {
      const clienteSelecionado = this.selectedCliente;
      if (clienteSelecionado === 0 || isNaN(clienteSelecionado)) {
        this.$emit("clienteSelecionado", null);
      } else {
        this.$emit("clienteSelecionado", clienteSelecionado);
      }
      this.closeModal();
    },
  },
};
</script>
